class WebalarmShowcase extends HTMLElement {
  connectedCallback() {
    if (this.dataset.cfBound === 'true') return;
    this.dataset.cfBound = 'true';
    this.track = this.querySelector('[data-cf-track]');
    this.slides = Array.from(this.querySelectorAll('[data-cf-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-cf-dot]'));
    this.caption = this.querySelector('[data-cf-caption]');
    this.prev = this.querySelector('[data-cf-prev]');
    this.next = this.querySelector('[data-cf-next]');
    this.frame = this.querySelector('[data-cf-frame]');
    this.viewport = this.querySelector('[data-cf-viewport]');
    this.index = 0;
    this.timer = 0;
    this.touchX = null;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
    this.speed = Math.max(3, Number(this.dataset.speed) || 5) * 1000;

    if (this.slides.length < 2) {
      this.querySelector('[data-cf-controls]')?.setAttribute('hidden', '');
      this.go(0);
      return;
    }

    this.prev?.addEventListener('click', () => {
      this.go(this.index - 1);
      this.play();
    });
    this.next?.addEventListener('click', () => {
      this.go(this.index + 1);
      this.play();
    });
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.go(index);
        this.play();
      });
    });
    this.frame?.addEventListener('mouseenter', () => this.stop());
    this.frame?.addEventListener('mouseleave', () => this.play());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.play());
    this.viewport?.addEventListener(
      'touchstart',
      (event) => {
        this.touchX = event.touches[0].clientX;
        this.stop();
      },
      { passive: true }
    );
    this.viewport?.addEventListener('touchend', (event) => {
      if (this.touchX === null) return;
      const delta = event.changedTouches[0].clientX - this.touchX;
      if (Math.abs(delta) > 40) this.go(this.index + (delta < 0 ? 1 : -1));
      this.touchX = null;
      this.play();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop();
      else this.play();
    });
    this.go(0);
    this.play();
  }

  disconnectedCallback() {
    this.stop();
  }

  go(next) {
    const count = this.slides.length;
    if (!count) return;
    this.index = (next + count) % count;
    if (this.track) {
      this.track.style.transform = 'translateX(-' + this.index * 100 + '%)';
    }
    this.dots.forEach((dot, index) => {
      if (index === this.index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    this.slides.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index === this.index ? 'false' : 'true');
    });
    const current = this.slides[this.index];
    if (this.caption) {
      this.caption.innerHTML = current?.dataset.caption || '';
    }
    if (this.frame) {
      this.frame.classList.toggle('cf-imac--monitor', current?.dataset.monitor === 'true');
    }
  }

  play() {
    this.stop();
    if (!this.autoplay || this.slides.length < 2) return;
    this.timer = window.setInterval(() => this.go(this.index + 1), this.speed);
  }

  stop() {
    window.clearInterval(this.timer);
  }

  pause() {
    this.autoplay = false;
    this.stop();
  }

  resume() {
    this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
    this.play();
  }
}

if (!customElements.get('webalarm-showcase')) {
  customElements.define('webalarm-showcase', WebalarmShowcase);
}

document.addEventListener('shopify:block:select', (event) => {
  const slide = event.target.closest('[data-cf-slide]');
  const root = slide?.closest('webalarm-showcase');
  if (!root || !slide) return;
  const index = Array.from(root.querySelectorAll('[data-cf-slide]')).indexOf(slide);
  root.pause();
  root.go(index);
});

document.addEventListener('shopify:block:deselect', (event) => {
  const root = event.target.closest('webalarm-showcase');
  root?.resume();
});
